import { render, staticRenderFns } from "./btn-tertiary3.vue?vue&type=template&id=9d0d987a&scoped=true&"
import script from "./btn-tertiary3.vue?vue&type=script&lang=js&"
export * from "./btn-tertiary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d0d987a",
  null
  
)

export default component.exports